<template>
  <div id="iContent">
    <div id="conList">
      <div id="wTable">
        <div id="tab1">职位</div>
        <div id="tab2">发布时间</div>
      </div>
      <router-link id="oneCon" v-for="(item, index) in tableData"
        :key="index" tag="div" :to="{path:'/about/talentdetials/talentdetials', query:{id:item.id}}">
        <div id="navdht"><img src="../../assets/img/navdh.png"></div>
        <div>
          <div class="text">{{ item.jobs }}</div>
          <div><span>{{ item.starttime }}</span></div>
        </div>
      </router-link>
    </div>
    <el-pagination background @size-change="mhandleSizeChange" @current-change="mhandleCurrentChange" :current-page="currentPage"
      :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal.total" style="margin-top: 1em;text-align:right">
    </el-pagination>

  </div>
</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        pageTotal: [],
        currentPage: 1,
        pageSize: 10,
        pageNum: 1,
      }
    },
    mounted() {
      this.handleSearch();
      let eWidth = document.body.clientWidth;
      document.getElementById("conList").style.width = eWidth * 0.72 + "px";
      document.getElementById("wTable").style.width = eWidth * 0.72 - 10 + "px";
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val;
        this.search();
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.search();
      },
      mhandleSizeChange(val) {
        this.pageSize = val;
        this.msearch();
      },
      mhandleCurrentChange(val) {
        this.pageNum = val;
        this.msearch();
      },
      handleSearch() {
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/talent/talent?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        that.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.tableData = cData.data.list;
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  p {
    margin: 0;
  }

  #wTable {
    height: 60px;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    margin-left: 10px;
  }

  #tab1 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    left: 50px;
    font-weight: bold;
  }

  #tab2 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    right: 100px;
    font-weight: bold;
  }

  #navdht {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 20px;
    left: 20px;
    cursor: pointer;
  }

  #navdht>img {
    width: 100%;
    height: 100%;
  }

  #oneCon {
    height: 60px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
    margin-left: 40px;
  }

  #oneCon>div>div:nth-child(1) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    left: 50px;
  }

  #oneCon>div>div:nth-child(2) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    right: 95px;
  }

  #oneCon>div>.text {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about/talent.vue